export const currencies = {
  DES: "DES",
  USDT: "USDT"
};

export function getBalance(balances, currency) {
  return balances?.find((item) => item.currency === currency);
}
